import { render } from "./BurgerMenu.vue?vue&type=template&id=15541c99"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"
script.render = render

export default script